// Translation: Reset > Landing > Form (English)
export default Object.freeze({
	form: {
		actions: {
			changePassword: 'Change password',
			continue: 'Continue'
		},
		fields: {
			code: {
				placeholder: 'Enter the code'
			},
			email: {
				placeholder: 'Enter your email'
			},
			password: {
				options: {
					hide: {
						label: 'Hide password'
					},
					show: {
						label: 'Show password'
					}
				},
				placeholder: 'Enter new password'
			},
			passwordConfirmation: {
				placeholder: 'Confirm password'
			}
		},
		options: {
			resendCode: {
				label: {
					idle: 'Resend code',
					success: 'Code resent!'
				}
			}
		},
		title: {
			codeVerification: 'Code verification',
			information: 'Information',
			passwordReset: 'Password reset'
		}
	}
})
